import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=77aaadc0&"
import script from "./Matrix.vue?vue&type=script&lang=js&"
export * from "./Matrix.vue?vue&type=script&lang=js&"
import style0 from "./Matrix.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports